module.exports = __webpack_public_path__ + "img/add.d7721d16.svg";